import type { ReactNode } from "react";
import { READING_ICONS } from "~/modules/analytics/components/readings";
import { LOOP, type LoopStage } from "~/modules/analytics/lib/loop";

export function InsightIcon({ tone, children }: { tone: LoopStage["key"]; children: ReactNode }) {
	return (
		<span className="insight-icon" data-tone={tone} aria-hidden>
			{children}
		</span>
	);
}

export function StageIcon({ step }: { step: number }) {
	const stage = LOOP[step - 1] ?? LOOP[0];
	return <InsightIcon tone={stage.key}>{READING_ICONS[stage.readings[0].slug]}</InsightIcon>;
}
